import React from 'react'
import { connect } from 'react-redux'

class OfficeHeaderTitle extends React.Component {
  componentDidMount = () => {
    this.setTitle(this.props.children)
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.children !== this.props.children) {
      this.setTitle(this.props.children)
    }
  }
  componentWillUnmount = () => {
    this.setTitle('')
  }
  setTitle = (title) => {
    this.props.dispatch({ type: 'SET_OFFICE_HEADER_TITLE', officeHeaderTitle: title })
  }
  render() {
    return null
  }
}

export default connect(null, null)(OfficeHeaderTitle)
